import { store } from 'app/store';
import axios from 'axios';
import { TierInfo } from 'store/tiers/tiers.interface';
import urls from 'utils/urls';

const state = store.getState();

export const getTiersService: () => Promise<{ data: TierInfo }> = () => {
  try {
    const tiers = state.tiers.data;
    if (tiers) {
      return Promise.resolve({ data: tiers });
    } else {
      return axios
        .get(urls.tiers)
        .then((res) => {
          return { data: res.data.response as TierInfo };
        })
        .catch((err) => {
          throw err;
        });
    }
  } catch (ex) {
    return Promise.reject(ex);
  }
};
